import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  toggle(event) {
    this.inputTarget.type = event.target.checked ? "text" : "password"
  }
}
